import React, { useState, useEffect } from 'react';
import { db } from './firebaseConfig';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';

// Imports dos componentes MUI
import {
  Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Box, Grid,
  IconButton, Select, MenuItem, FormControl, InputLabel
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ManutencaoModal = ({ onClose, onSave, manutencaoParaEditar }) => {
  const [chales, setChales] = useState([]);
  const [chaleId, setChaleId] = useState('');
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [motivo, setMotivo] = useState('');

  useEffect(() => {
    // Busca a lista de chalés para preencher o seletor
    const fetchChales = async () => {
      const q = query(collection(db, "chales"), orderBy("numero"));
      const querySnapshot = await getDocs(q);
      setChales(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchChales();

    if (manutencaoParaEditar) {
      setChaleId(manutencaoParaEditar.chaleId || '');
      setDataInicio(manutencaoParaEditar.dataInicio || '');
      setDataFim(manutencaoParaEditar.dataFim || '');
      setMotivo(manutencaoParaEditar.motivo || '');
    }
  }, [manutencaoParaEditar]);

  const handleSave = () => {
    const chaleSelecionado = chales.find(c => c.id === chaleId);
    const dados = {
      chaleId,
      chaleNumero: chaleSelecionado?.numero || '',
      chaleNome: chaleSelecionado?.nome || '',
      dataInicio,
      dataFim,
      motivo
    };
    onSave(dados);
  };

  return (
    <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {manutencaoParaEditar ? 'Editar Agendamento' : 'Agendar Manutenção'}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <FormControl fullWidth margin="normal" required>
            <InputLabel id="chale-select-label">Chalé</InputLabel>
            <Select
              labelId="chale-select-label"
              value={chaleId}
              label="Chalé"
              onChange={e => setChaleId(e.target.value)}
              disabled={!!manutencaoParaEditar} // Não permite trocar o chalé na edição
            >
              {chales.map(chale => (
                <MenuItem key={chale.id} value={chale.id}>{chale.nome}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Data de Início"
                type="date"
                required
                fullWidth
                value={dataInicio}
                onChange={e => setDataInicio(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Data de Término"
                type="date"
                required
                fullWidth
                value={dataFim}
                onChange={e => setDataFim(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
          <TextField
            label="Motivo (Opcional)"
            margin="normal"
            fullWidth
            multiline
            rows={3}
            value={motivo}
            onChange={e => setMotivo(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button onClick={onClose} variant="outlined" color="inherit">Cancelar</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Salvar Agendamento
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManutencaoModal;